import { APIResponse, PreviewEmailResponse } from '@acp/shared';
import { getBFFApiClient } from '@acp/feature/auth';
import HttpStatusCodes from 'http-status-codes';
import { AxiosProgressEvent } from 'axios';

async function getEmailPreview(emailType: string, meta: unknown) {
    const response = await getBFFApiClient().post<APIResponse<PreviewEmailResponse>>(
        `/v1/email/${emailType}/preview`,
        {
            meta,
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get email preview');
    }

    return response.data.data;
}

async function downloadEmail(emailType: string, meta: unknown) {
    const response = await getBFFApiClient().post<Blob>(
        `/v1/email/${emailType}/download`,
        {
            meta,
        },
        {
            responseType: 'blob',
        }
    );

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to get email preview');
    }

    return URL.createObjectURL(response.data);
}

async function uploadImage(
    formData: FormData,
    progressCallBack?: (progressEvent: AxiosProgressEvent) => void
) {
    const response = await getBFFApiClient().put<
    APIResponse<{ success: true; public_url: string; error: string | null }>
    >('/v1/misc/image/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
            if (progressCallBack != null && typeof progressCallBack === 'function') {
                progressCallBack(progressEvent);
            }
        },
    });

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(response.data.error ?? 'Failed to upload image');
    }

    return response.data.data;
}

export { getEmailPreview, downloadEmail, uploadImage };
